const WatchVideoTutorial = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2083 3.125C6.29632 3.125 3.125 6.29632 3.125 10.2083C3.125 14.1204 6.29632 17.2917 10.2083 17.2917C14.1204 17.2917 17.2917 14.1204 17.2917 10.2083C17.2917 6.29632 14.1204 3.125 10.2083 3.125ZM1.875 10.2083C1.875 5.60596 5.60596 1.875 10.2083 1.875C14.8107 1.875 18.5417 5.60596 18.5417 10.2083C18.5417 14.8107 14.8107 18.5417 10.2083 18.5417C5.60596 18.5417 1.875 14.8107 1.875 10.2083Z"
      fill="currentColor"
    />
    <path
      d="M8.54167 12.5449V7.87172C8.54167 7.53697 8.91647 7.33888 9.19306 7.52746L12.6201 9.86407C12.8627 10.0295 12.8627 10.3872 12.6201 10.5526L9.19306 12.8892C8.91647 13.0778 8.54167 12.8797 8.54167 12.5449Z"
      fill="currentColor"
    />
  </svg>
)

export default WatchVideoTutorial
